import React, { memo, useCallback } from 'react';
import { useIntl } from 'react-intl';
import { RouteComponentProps, withRouter } from 'react-router';

import { Button } from '@xsolla/ui-core';

import { BabkaOauthSettings } from '../../../../api/configurations/babkaLogin/types';
import { useConfig } from '../../../../contexts/config';
import { usePaths } from '../../../../routes/routesHelper';
import { Wrapper } from './styleBottomRow';

type Props = RouteComponentProps & {
  projectId?: string;
  metricsName?: string;
  isBabkaLogin?: boolean;
  client: BabkaOauthSettings;
};

const BottomRow = ({
  projectId,
  metricsName,
  history,
  isBabkaLogin,
  client
}: Props): JSX.Element => {
  const { babkaLoginPath, navigationPath } = usePaths();
  const intl = useIntl();
  const { xsollaAnalytics } = useConfig();

  const onButtonClick = useCallback(() => {
    if (projectId && !isBabkaLogin) {
      xsollaAnalytics.sendClick(`login_pa_module__${metricsName}`, projectId);
      history.push({ pathname: navigationPath(projectId) });
    } else if (isBabkaLogin && client.id) {
      history.push({ pathname: babkaLoginPath(client.id), state: client });
    }
  }, []);

  return (
    <Wrapper>
      <Button
        data-test-id="btn-configure-project"
        palette="brand"
        look="tertiary"
        size="sm"
        onClick={onButtonClick}>
        {intl.formatMessage({ id: 'dashboard.login-card.button' })}
      </Button>
    </Wrapper>
  );
};

export default memo(withRouter(BottomRow));
